import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { HorizontalPlatformSearch } from 'src/components/navigation/src/components/horizontal-nav/horizontal-platform-search';
import { WorkspaceLink } from 'src/components/workspace-link';
import { useRecentData } from 'src/hooks/recent-data';
import { toggleSearchDrawer } from 'src/redux/global/actions/toggle-search-drawer';
import {
  getIsSearchDrawerOpen,
  getIsWorkspaceAdmin,
} from 'src/selectors/global-selectors';
import {
  publishScreenEvent,
  publishUiEvent,
} from 'src/utils/analytics/publish';

import { useTopNavData } from './hooks';

export const TopNavSearch = () => {
  const dispatch = useDispatch();
  const isSearchDrawerOpen = useSelector(getIsSearchDrawerOpen);
  const isWorkspaceAdmin = useSelector(getIsWorkspaceAdmin);

  const navData = useTopNavData();

  const onSearchDrawerClose = useCallback(
    () => dispatch(toggleSearchDrawer(false)),
    [dispatch]
  );
  const onSearchDrawerOpen = useCallback(
    () => dispatch(toggleSearchDrawer(true)),
    [dispatch]
  );

  const { loadRecentRepositories, recentRepositories } = useRecentData();

  return (
    <HorizontalPlatformSearch
      currentRepository={navData.currentRepository}
      currentWorkspace={navData.currentWorkspace}
      defaultWorkspace={navData.defaultWorkspace}
      // It doesn't seem like HorizontalPlatformSearch is using this, so it's a good candidate for clean-up
      // once Nav v4 is rolled out
      isExpanded={isSearchDrawerOpen}
      isLoggedIn={!navData.isCurrentUserAnonymous}
      isSearchDrawerOpen={isSearchDrawerOpen}
      isWorkspaceAdmin={isWorkspaceAdmin}
      loadRepositories={loadRecentRepositories}
      onSearchDrawerClose={onSearchDrawerClose}
      onSearchDrawerOpen={onSearchDrawerOpen}
      publishScreenEvent={publishScreenEvent}
      publishUiEvent={publishUiEvent}
      repositories={recentRepositories}
      shouldFillContainer
      workspaceLinkComponent={WorkspaceLink}
    />
  );
};
